import axios from "axios";
const API = axios.create({baseURL:`${process.env.REACT_APP_BACKEND_URL}`,withCredentials: true});
API.defaults.headers.post["Content-Type"] = "application/json";
API.defaults.headers.common["Authorization"] = `${process.env.REACT_APP_API_KEY}`;
class ProductsService {
    static getProducts({ category = "", page = 1 }) {
        const query = new URLSearchParams();
        query.append("page", page);
        if (category) query.append("category", category);
        return API.get(`/get-items?${query.toString()}`);
    }
    static getSingleProduct(productId) {
        return API.get(`/api/items/${productId}`);
    }
}
export default ProductsService;